import { useMutation } from 'react-query';

import { NewForumPost, adminUpdateForumPost } from '@utils/backend-api/forumPosts';

export default function useForumPostAdminUpdate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((values: NewForumPost) =>
    adminUpdateForumPost(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
